enum AuthStepsEnum {
  EmailOrUsername = 'emailOrUsername',
  FinishSignUp = 'finishSignUp',
  EnterPassword = 'enterPassword',
  EnterSms2fa = 'enterSms2fa',
  MoreOptions = 'moreOptions',
}

export default AuthStepsEnum;
